"use client";

import { useTranslation } from "react-i18next";
import { Form } from "@/app/components/ui/form";
import { Button } from "@/app/components/ui/button";
import {
  useContactForm,
  ContactInformationSection,
  InquiryDetailsSection,
  MessageSection,
  FormStatusMessages,
} from "@/app/components/features/contact";

export default function ContactForm() {
  const { t } = useTranslation();
  const { form, preferredContactMethod, submitStatus, onSubmit, errorMessage } = useContactForm();

  return (
    <section className="w-full flex-1 px-4 sm:px-6 md:px-12 py-8 md:py-16 bg-[linear-gradient(to_bottom,#ffffff_15%,#1E2E25_15%)] md:bg-[linear-gradient(to_bottom,#ffffff_22%,#1E2E25_22%)] lg:bg-[linear-gradient(to_bottom,#ffffff_28%,#1E2E25_28%)] xl:bg-[linear-gradient(to_bottom,#ffffff_35%,#1E2E25_35%)] flex flex-col justify-start">
      <div className="mx-auto max-w-7xl w-full">
        <div className="mx-auto max-w-4xl bg-ui-page shadow-lg border border-ui-border p-6 sm:p-8 md:p-12">
          <div className="mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-normal text-ui-card mb-2">
              {t("Write us")}
            </h2>
            <div className="h-px w-16 bg-[#E3F1CE]"></div>
          </div>
          
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} noValidate className="space-y-10">
              {/* Honeypot (bots often fill; humans never see). Do not remove. */}
              <div
                aria-hidden="true"
                style={{
                  position: "absolute",
                  left: "-10000px",
                  top: "auto",
                  width: "1px",
                  height: "1px",
                  overflow: "hidden",
                }}
              >
                <label htmlFor="website">Website</label>
                <input
                  id="website"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  inputMode="url"
                  {...form.register("website")}
                />
              </div>

              <ContactInformationSection 
                control={form.control} 
                preferredContactMethod={preferredContactMethod} 
              />
              
              <div className="border-t border-ui-border/50 my-8"></div>
              
              <InquiryDetailsSection control={form.control} />
              
              <div className="border-t border-ui-border/50 my-8"></div>
              
              <MessageSection control={form.control} />

              <FormStatusMessages status={submitStatus} errorMessage={errorMessage} />

              <div className="flex justify-end pt-4">
                <Button
                  type="submit"
                  variant="primary"
                  disabled={form.formState.isSubmitting}
                  className="disabled:opacity-50 disabled:cursor-not-allowed min-w-[140px]"
                >
                  {form.formState.isSubmitting ? (
                    <span className="flex items-center gap-2">
                      <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                      </svg>
                      {t("Sending...")}
                    </span>
                  ) : (
                    t("Send Message")
                  )}
                </Button>
              </div>
            </form>
          </Form>
        </div>
      </div>
    </section>
  );
}
